import { Navigate } from "react-router";
function RedirectToDashboard() {
  return <Navigate to="/dashboard" replace />;
}
export {
  RedirectToDashboard
};
